const state = {
    demo: null,
    noAuthority: false, // 403
    serverError: false, // 500
    accountInfo: null, // 用户信息
    isLogin: false, // 是否登录

};
export default state;